module.exports = {
      id: "googleplay-usage",
      viewBox: "0 0 135 40",
      url: __webpack_public_path__ + "svg-sprite-84e6ba0859b67d2a822c8ad28bb7a5bc.svg#googleplay",
      toString: function () {
        return this.url;
      }
    }